const RECEIVE_ALL_OMNI_KEYWORD_CATEGORIES = 'src/omniKeywordCategories/RECEIVE_ALL_OMNI_KEYWORD_CATEGORIES' as const;

export default { RECEIVE_ALL_OMNI_KEYWORD_CATEGORIES };
